import request from '@/utils/login-request'
import request1 from '@/utils/login'
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

export function getUserInfo() {
  return request({
    url: '/user/get/getuserAndAction',
    method: 'get'
  })
}
export function newlogin(username, password) {
  return request1({
    url: '/login',
    method: 'post',
    data: {
      username: username,
      password: password
    }
  })
}

// 模糊查询 根据用户名搜索
export function getUserInfoByName(params) {
  return request({
    url: '/user/get/list',
    method: 'get',
    params: { state: 1, ...params }
  })
}

// 根据用户id集合获取用户信息列表数据
export function getUserInfoByIdList(params) {
  return request({
    url: `/user/get/users`,
    method: 'post',
    data: params
  })
}

// 获取业务系统树形菜单
export function bussinessTree(reqParams) {
  return request({
    url: `/usermenu/get/bussinesstree/${reqParams}`,
    method: 'get'
    // params: reqParams
  })
}

// 根据个人id搜索人名
export function getUserInfoById(userId) {
  return request({
    url: `/user/get/${userId}`,
    method: 'get'
    // params:params
  })
}

// 查部门
export function getDepartmentByName(params) {
  return request({
    url: `/department/get/longDept`,
    method: 'get',
    params: params
  })
}

export function getDepartmentById(id) { // 单个部门信息查询
  return request({
    url: '/department/get/' + id,
    method: 'get'

  })
}

export function getDepartmentByIds(ids) { // 多个
  return request({
    url: '/department/get/ids',
    method: 'post',
    data: ids

  })
}
// 获取系统列表
export function sysTree() {
  return request({
    url: `/userSystemMap/get/userId/forlogin`,
    method: 'get'
    // params: reqParams
  })
}

